import isUndefined from 'lodash/isUndefined';
import { sdkRequest } from '@eb/http';

import { formatQuery } from 'url-lib';

import { fetchAuthentication } from './utils';

import { GA_EVENTBRITE } from '../constants/analytics';

export const SEND_RESET_PASSWORD_URL = '/api/v3/users/password_reset_email/';
export const SEND_LINK_ACCOUNT_URL = '/api/v3/users/send_link_account_email/';
export const SEND_SOFT_ACCOUNT_ACTIVATION_EMAIL_URL =
    '/users/send_activation_email/';
export const SEND_PASSWORDLESS_EMAIL_URL =
    '/api/v3/users/send_passwordless_login_email/';
/**
 * API to send email to reset password
 */
export const sendResetPasswordEmail = (
    email,
    mustLinkAccount = false,
    sourceProvider,
) => {
    const body = {
        email,
        application: 'web',
        must_link_account: mustLinkAccount,
    };

    // external_provider is only sent for facebook and apple
    if (sourceProvider != GA_EVENTBRITE && !isUndefined(sourceProvider)) {
        body['external_provider'] = sourceProvider;
    }

    return sdkRequest(SEND_RESET_PASSWORD_URL, {
        method: 'POST',

        body: JSON.stringify(body),
    })
        .then((response) => response)
        .catch((error) => {
            const statusCode = error.response ? error.response.status : 400;
            if (statusCode === 200) {
                // 200 Code It's Ok
                return Promise.resolve();
            } else {
                throw error;
            }
        });
};
/**
 *API to send Magic Link to link account
 */
export const sendEmailLinkAccount = (email, socialProvider) =>
    sdkRequest(SEND_LINK_ACCOUNT_URL, {
        method: 'POST',
        body: JSON.stringify({
            email: email,
            external_provider: socialProvider,
        }),
    });
/**
 * API to send email activation for Soft Account
 */
export const sendSoftAccountActivationEmail = (email, destination = '') => {
    return fetchAuthentication({}, SEND_SOFT_ACCOUNT_ACTIVATION_EMAIL_URL, {
        method: 'POST',
        body: formatQuery({ email, destination }),
    });
};

export const sendPasswordlessEmail = (email) => {
    return sdkRequest(SEND_PASSWORDLESS_EMAIL_URL, {
        method: 'POST',
        body: JSON.stringify({ email }),
    })
        .then((response) => response)
        .catch((error) => {
            const statusCode = error.response ? error.response.status : 400;
            if (statusCode === 200 || statusCode === 204) {
                // 200/204 Code It's Ok
                return Promise.resolve();
            } else {
                throw error;
            }
        });
};
